import Model from 'flarum/common/Model';

export default class KnowledgeModule extends Model {}

Object.assign(KnowledgeModule.prototype, {
  code: Model.attribute('code'),
  title: Model.attribute('title'),
  description: Model.attribute('description'),
  levelCode: Model.attribute('level_code'),
  swordLevel: Model.attribute('sword_level'),
  sortOrder: Model.attribute('sort_order'),
  price: Model.attribute('price'),
  isActive: Model.attribute('is_active'),
  articleCount: Model.attribute('article_count'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  level: Model.hasOne('level'),
});
